import { render } from "./ScheduleService.vue?vue&type=template&id=30c70968&lang=true"
import script from "./ScheduleService.vue?vue&type=script&lang=js"
export * from "./ScheduleService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/ScheduleService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30c70968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30c70968', __exports__)) {
    api.reload('30c70968', __exports__)
  }
  
  module.hot.accept("./ScheduleService.vue?vue&type=template&id=30c70968&lang=true", () => {
    api.rerender('30c70968', render)
  })

}


export default __exports__